const defaultPalette = [
  // '#51689b', '#ce5c5c', '#fbc357', '#8fbf8f', '#659d84', '#fb8e6a', '#c77288', '#786090', '#91c4c5', '#6890ba'
  // '#5470c6',
  // '#91cc75',
  // '#fac858',
  // '#ee6666',
  // '#73c0de',
  // '#3ba272',
  // '#fc8452',
  // '#9a60b4',
  // '#ea7ccc'
  '#a6cee3','#1f78b4','#b2df8a','#33a02c','#fb9a99','#e31a1c','#fdbf6f',
  '#ff7f00','#cab2d6','#6a3d9a','#ffff99','#b15928','#8dd3c7','#FF9671',
  '#FF6F91','#D65DB1','#845EC2'
];

const tableVerticalBar = (data) => {
  const defaultConfig = {
    tooltip: {
      trigger: 'item'
    },
    grid: {
      left: '20%',
      right: '20%',
      bottom: '20%',
      top: '20%',
      containLabel: true
    },
    xAxis: {
      type: 'value'
    },
    yAxis: {
      type: 'category',
      data: data.x
    },
    series: {
      data: data.y,
      type: 'bar',
      id: 'distribution',
      itemStyle: {
        borderRadius: [2,2,2,2],
        color: (params) => {
          return defaultPalette[params.dataIndex % defaultPalette.length]
        },
      },
      animationDuration: 1000,
      animationDurationUpdate: 1000,
      universalTransition: true
    }
  }

  const opt = Object.assign({}, defaultConfig)
  
  return opt
}
  
export default tableVerticalBar